module.exports = __webpack_public_path__ + "static/media/close.a8ae6289.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/close.png
// module id = 80
// module chunks = 0